import React, { useState } from 'react';
import './styles/ContactPage.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const mailtoLink = `mailto:jackmayr2@gmail.com?subject=Message from jackmayr.com&body=Name: ${formData.name}%0D%0AEmail: ${formData.email}%0D%0AMessage: ${formData.message}`;
    window.location.href = mailtoLink;
  };

  return (
    <div className="contact-page">
      <h1>Reach out!</h1>
      <p>Have questions or want to collaborate? Get in touch with me—I’d love to hear from you!</p>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="name">Name:</label>
          <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required />
        </div>
        <div>
          <label htmlFor="email">Email:</label>
          <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
        </div>
        <div>
          <label htmlFor="message">Message:</label>
          <textarea id="message" name="message" value={formData.message} onChange={handleChange} required></textarea>
        </div>
        <button type="submit">Send</button>
      </form>
      <div className="contact-links">
        <a href="https://www.linkedin.com/in/jack-mayr-912486168/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
        <a href="https://github.com/JackMayr2" target="_blank" rel="noopener noreferrer">GitHub</a>
        <a href="https://www.goodreads.com/user/show/152850044-jack-mayr" target="_blank" rel="noopener noreferrer">GoodReads</a>
      </div>
    </div>
  );
}

export default Contact;